import { render, staticRenderFns } from "./WeProductIcon.vue?vue&type=template&id=cfd76704&"
import script from "./WeProductIcon.vue?vue&type=script&lang=js&"
export * from "./WeProductIcon.vue?vue&type=script&lang=js&"
import style0 from "./WeProductIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports